module.exports = __webpack_public_path__ + "static/media/atomizador_rotativo_tela.84e58a3d.png";